import React from 'react'
import styled from "@emotion/styled";
import sv from "../../../styles/marketing";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";

// STYLE ##########################################################

export const infoContainerWidth = 275;

const InfoTitle = styled(`div`)`
  ${sv.h3};
  margin-top: 10px;
`;

const InfoText = styled(`div`)`
  font-size: 14px;
  color: ${sv.colors.grey};
  margin-top: 10px;
`;

const PitchButton = styled('div')`
  font-size: 15px;
  ${sv.buttonBase};
  background: ${sv.colors.cta};
  color: ${sv.colors.light};
  box-shadow: 0 2px 4px rgba(0,0,0,.05);
  &:hover {
    box-shadow: 0 3px 6px rgba(0,0,0,.1);
  }
  margin: 32px 0;
`;

const InfoPitchButton = styled(PitchButton)`
  border: 1px solid ${sv.colors.cta};
  background: none;
  color: ${sv.colors.cta};
  font-size: 14px;
  font-weight: 600;
  margin: 10px 0 0 0;
`;

const InfoContainer = styled('div')`
  flex: 1;
  ${props => props.fullWidth ? "" : "max-width: " + infoContainerWidth + "px"};
  ${props => props.fullWidth ? "" : "min-width: 140px"};
  ${props => props.fullWidth ? "width: 85%" : ""};
  padding: 20px;
  background: ${sv.colors.light};
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: 1px solid ${sv.colors.subtleGrey};
  margin-bottom: 20px;
`;

const InfoHeader = styled('div')`
  height: 17px;
  margin: -20px -20px 0 -20px;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  background-color: rgba(246, 135, 31, 0.6)
`;

// COMPONENT ##########################################################

export const ExampleInfo = ({collectionInstance, fullWidth = false}) => {
	const history = useHistory();
	const {t} = useTranslation("examples");
	return (
			<>
				{collectionInstance.isInfoPresent &&
				<InfoContainer fullWidth={fullWidth}>
					<InfoHeader/>
					<InfoTitle>{collectionInstance.info.title}</InfoTitle>
					<InfoText>{collectionInstance.info.text}</InfoText>
					<InfoPitchButton onClick={() => history.push('/signup')}>{t("Get Started")}</InfoPitchButton>
				</InfoContainer>
				}
			</>
	);
}
